import * as React from 'react';
import { UserGroup } from '../enums';
import { Switch, Route, withRouter, RouteComponentProps, Redirect } from 'react-router-dom';
import { AppHookProvider } from '../utils/rest-api/useAppHookContext';
import PrivateRoute from './private-route';
import { isAdvReimburseEnabledForCenter, isAdvReimburseEnabledCentersLoaded } from '@nkr/views/donors/watr/components/adv-reimburse-enabled-centers';
import App from '../components/app';
import Login from '../components/security/login';
import Logout from '../components/security/logout';
import Layout from '../components/layout';
import Print from '../components/print';
import Home from '@nkr/views/home/home';
import SwapManagement from '@nkr/views/swap-management';
import EmailFamily from '@nkr/views/email-tags';
import EmailEngine from '@nkr/views/email-engine';
import EmailTemplateEdit from '@nkr/views/email-engine/edit';
import EmailTemplatePreview from '@nkr/views/email-engine/preview';
import AdpDonor from '@nkr/views/adp-donors';
import AdpVoucherHolders from '@nkr/views/adp-voucher-holders';
import ShortCodeCreator from '@nkr/views/short-codes';
import QaRegistration from '@nkr/views/qa/registration';
import CenterAdmin from '@nkr/views/center-admin';
import CronJobs from '@nkr/views/admin/automated-jobs';
import Contacts from '@nkr/views/contacts/list';
import ContactAddEdit from '@nkr/views/contacts/add-edit';
import CourierLogistics from '@nkr/views/courier-logistics';
import CourierSwapCallsScheduleReport from '@nkr/views/reports/courier-swap-calls-schedules';
import LogisticsPlan from '@nkr/views/center-admin/action-center/pending-swaps/logistics-plan';
import BeaconOverlayMap from '@nkr/views/beacon-overlay-map';
import CoachActionCenter from '@nkr/views/microsite/coach/coach-action-center';
import CoachFilteredList from '@nkr/views/microsite/coach/coach-filtered-list';
import { CoachListTab } from '@nkr/enums/index';
import CoachMicrositeView from '@nkr/views/microsite/coach/microsite-view';
import MicrositeCoachPerformance from '@nkr/views/reports/microsite-coach-performance/microsite-coach-performance';
import SelectAccount from '@nkr/components/security/select-account';
import Nkrlab from '@nkr/views/nkr-lab';
import ViewExpertSystemOrder from '@nkr/views/expert-system/view-order';
import NkrlabDonorOptions from '@nkr/views/nkr-lab/donor-options';
import IldaApp from '@nkr/views/dash/ilda';
import IldaUserCaseLoadLimits from '@nkr/views/dash/ilda/user-case-load-limits';
import TargetNew from "@nkr/views/target-new";
import QaMicrositeList from '@nkr/views/qa/microsites/list';
import ManageAccount from '@nkr/views/users/manage-account';
import QaCenterList from '@nkr/views/qa/centers';
import QaTaskList from '@nkr/views/qa/tasks';
import MoveTracker from '@nkr/views/swap-management/swaps/move-tracker';
import SwapTracker from '@nkr/views/swap-management/swaps/swap-tracker';
import ConfigureMatchRunNew from '@nkr/views/matching/configure-match-run-new';
import MatchRunList from '@nkr/views/matching/match-run-list';
import MatchRunResultsNew from '@nkr/views/matching/results-new';
import SwapCallsScheduleReport from '@nkr/views/reports/administration/swap-calls-schedules';
import UpdateOptnSrtrData from '@nkr/views/admin/update-optn-srtr-data';
import DashMonitoring from '@nkr/views/admin/dash-monitoring';
import HighDeclines from '@nkr/views/high-declines';
import CryoXmResultsRecordedLateReport from '@nkr/views/reports/cryo-xm-results-recorded-late';
import OrganPickupDeliveryReport from '@nkr/views/reports/performance/organ-pickup-and-delivery';
import NotFound from './not-found';
import CheekSwabRequest from '@nkr/views/cheek-swab-request-form';
import VoucherSimulationConfig from '@nkr/views/voucher-simulation/config';
import VoucherSimulationResults from '@nkr/views/voucher-simulation/results';
import EmailTestHarness from '@nkr/views/email-test-harness';
import DonorMentorCannedResponses from '@nkr/views/dash/donor-connect/donor-mentor-canned-responses';

const DocumentFindLab = React.lazy(() => import('@nkr/views/donors/watr/document-find-lab'));

import {
    CenterActionCenterRoutes,
    CenterBillingRoutes,
    CenterFollowUpRoutes,
    CenterMicrositeRoutes,
    CenterPassRoutes,
    CenterProfileRoutes,
    CenterRecipientRoutes,
    CenterReportRoutes,
    DashReferralSourceRoutes,
    DonorConnectRoutes,
    ReportRoutes,
    TicketingRoutes,
} from './routes/index';

import { donorProfileSections, subSections as donorSubsections } from '@nkr/views/donors/subsections';

import AdminContent from '@nkr/views/admin/content';
import MicrositeApprove from '@nkr/views/microsite/approve';
import MicrositeDecline from '@nkr/views/microsite/decline';
import MicrositeRecipientHistory from '@nkr/views/microsite/microsite-recipient-history';
import MicrositeAddEdit from '@nkr/views/microsite/add-edit';
import StrongBoxListing from '@nkr/views/strong-box/strong-box-listing';

import CreateAccount from '@nkr/components/security/create-account';
import OpoUserOpoEdit from '@nkr/views/admin/opo/opo-user-opo-edit';
import OpoLandingPage from '@nkr/views/opo/landing-page';
import OpoPortalEntry from '@nkr/views/opo/portal-entry';
// import OpoMoveTracker from '@nkr/views/admin/opo/opo-move-tracker';

const Dashboard = () => {
    return (
        <div>
            <h1>Dashboard!</h1>
        </div>
    );
}

interface INotAuthorizedProps extends RouteComponentProps<{ id: string }> { }

const NotAuthorizedBase = (props: INotAuthorizedProps) => {
    return (
        <div className='container'>
            <div className='row'>
                <div className='col-xs-12'>
                    <div style={{ padding: 20, fontSize: 16 }}>
                        <p>Unfortunately, you are not authorized to view the requested page.</p>

                        <p>To return to the login page, <a href={'/login'}>click here</a>.</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

const NotAuthorized = withRouter(NotAuthorizedBase);

export const adminGroups = [UserGroup.Admin];
export const nkrLabGroups = [UserGroup.Admin, UserGroup.NkrLabUser];
export const centerGroups = [UserGroup.Admin, UserGroup.CenterAdmin, UserGroup.CenterUser];
export const micrositeCoachGroups = [...centerGroups, UserGroup.Guest, UserGroup.MicrositeCoachOnly];
export const ticketingGroups = [UserGroup.Admin, UserGroup.NkdoUser, UserGroup.NkfUser, UserGroup.NkrMentor];
export const donorConnectCannedResponseGroups = [UserGroup.Admin, UserGroup.NkrMentor]
export const donorConnectGroups = [UserGroup.Admin, UserGroup.NkdoUser, UserGroup.NkfUser, UserGroup.NkdoMentor, UserGroup.NkrMentor];
export const logisticsGroups = [UserGroup.Admin, UserGroup.LogisticsProvider, UserGroup.LogisticsPhlebotUser];
export const opoGroups = [UserGroup.Admin, UserGroup.Opo, UserGroup.OpoAdmin];

const Parent = (props: RouteComponentProps<{}>) => {
    return (
        <Layout>
            <AppHookProvider>
                <Switch>
                    <Route path='/home' render={() => <Home />} />
                    <Route path='/dashboard' component={Dashboard} />
                    <Route exact path='/manage-account' component={ManageAccount} />
                    <Route exact path='/beacon-overlay-map' render={(props: any) => <BeaconOverlayMap {...props} isOps={true} />} />
                    <Route exact path='/move-tracker' render={() => <MoveTracker reloadCounts={null} isOps={true} isCourier={false} />} />
                    <Route exact path='/swap-tracker' render={() => <SwapTracker reloadCounts={null} isOps={true} />} />
                    <Route exact path='/cron-jobs' render={() => <CronJobs isOps={true} />} />
                    <Route exact path='/dash-monitoring' render={() => <DashMonitoring />} />
                    <PrivateRoute path='/manage-swaps' groups={adminGroups} component={SwapManagement} />
                    <PrivateRoute path='/one-way-tracker' groups={adminGroups} component={SwapManagement} />
                    <PrivateRoute path='/email-family' groups={adminGroups} component={EmailFamily} />
                    <PrivateRoute path='/email-engine' groups={adminGroups} component={EmailEngine} />
                    <PrivateRoute path='/email-template/:id' groups={adminGroups} component={EmailTemplateEdit} />
                    <PrivateRoute path='/email-template-preview/:id' groups={adminGroups} component={EmailTemplatePreview} />
                    <PrivateRoute path='/adp-donor' groups={adminGroups} component={AdpDonor} />
                    <PrivateRoute path='/adp-voucher-holders' groups={adminGroups} component={AdpVoucherHolders} />
                    {/* <PrivateRoute path='/gala-contacts' groups={adminGroups} component={GalaContacts} /> */}
                    <PrivateRoute path='/short-code-creator' groups={adminGroups} component={ShortCodeCreator} />
                    <PrivateRoute path='/report/cryo-xm-results-recorded-late' groups={adminGroups} render={() => <CryoXmResultsRecordedLateReport centerId={0} isCenterLogin={false} />} />
                    <PrivateRoute path='/voucher-simulation-config' groups={adminGroups} component={VoucherSimulationConfig} />
                    <PrivateRoute path='/voucher-simulation-results/:fileId' groups={adminGroups} render={({ match: { params: subParams } }) => <VoucherSimulationResults fileId={subParams.fileId} />} />
                    <PrivateRoute path='/email-test-harness' groups={adminGroups} component={EmailTestHarness} />
                    <PrivateRoute
                        path='/document-find-lab'
                        groups={adminGroups}
                        render={() => (
                            <React.Suspense fallback={<div>Loading…</div>}>
                                <DocumentFindLab />
                            </React.Suspense>
                        )}
                    />
                    <PrivateRoute path='/admin/donor-connect/canned-responses' groups={donorConnectCannedResponseGroups} component={DonorMentorCannedResponses} />
                    <PrivateRoute path='/admin/dash-referral-sources' groups={adminGroups} render={({ match: { url, params } }) => <DashReferralSourceRoutes url={url} {...params} />} />

                    <PrivateRoute
                        path='/qa'
                        groups={adminGroups}
                        render={({ match: { url, params } }) =>
                            <Switch>
                                <Route path={`${url}/registration`} component={QaRegistration} />
                                <Route path={`${url}/microsites`} component={QaMicrositeList} />
                                <Route path={`${url}/centers`} component={QaCenterList} />
                                <Route path={`${url}/tasks`} component={QaTaskList} />
                                <Route path={`${url}`} component={NotFound} />
                            </Switch>
                        }
                    />

                    <PrivateRoute
                        path='/strongbox'
                        groups={adminGroups}
                        render={({ match: { url, params } }) =>
                            <Switch>
                                <Route path={`${url}/listing/inventory`} render={() => <StrongBoxListing tabKey={0} isOpo={false} />} />
                                <Route path={`${url}/listing/orders`} render={() => <StrongBoxListing tabKey={1} isOpo={false} />} />
                                <Route path={`${url}/listing/usage-history`} render={() => <StrongBoxListing tabKey={2} isOpo={false} />} />
                                <Route path={`${url}/listing/inventory-reports`} render={() => <StrongBoxListing tabKey={3} isOpo={false} />} />
                                <Route path={`${url}/listing`} render={() => <StrongBoxListing tabKey={0} isOpo={false} />} />
                            </Switch>
                        }
                    />

                    <PrivateRoute
                        path='/strongbox-opo'
                        groups={adminGroups}
                        render={({ match: { url, params } }) =>
                            <Switch>
                                <Route path={`${url}/listing/orders`} render={() => <StrongBoxListing tabKey={1} isOpo={true} />} />
                                <Route path={`${url}/listing/usage-history`} render={() => <StrongBoxListing tabKey={2} isOpo={true} />} />
                                <Route path={`${url}/listing/inventory-reports`} render={() => <StrongBoxListing tabKey={3} isOpo={true} />} />
                                <Route path={`${url}/listing`} render={() => <StrongBoxListing tabKey={0} isOpo={true} />} />
                            </Switch>
                        }
                    />

                    <PrivateRoute
                        path='/matching'
                        groups={adminGroups}
                        render={({ match: { url, params } }) =>
                            <Switch>
                                <Route path={`${url}/match-run/configure-new`} component={ConfigureMatchRunNew} />
                                <Route path={`${url}/match-run/list/new`} render={() => <MatchRunList isNew={true} />} />
                                <Route path={`${url}/match-run/list`} render={() => <MatchRunList isNew={false} />} />
                                <Route path={`${url}/results-new/:matchRunId`} component={MatchRunResultsNew} />
                            </Switch>
                        }
                    />

                    <PrivateRoute
                        path='/report'
                        groups={adminGroups}
                        render={({ match: { url, params } }) =>
                            <ReportRoutes url={url} {...params} />
                        }
                    />

                    <PrivateRoute
                        path='/ticketing'
                        groups={ticketingGroups}
                        render={({ match: { url, params } }) =>
                            <TicketingRoutes url={url} {...params} />
                        }
                    />

                    <PrivateRoute
                        path='/contacts'
                        groups={adminGroups}
                        render={({ match: { url, params } }) =>
                            <Switch>
                                <Route path={`${url}`} render={() => <Contacts isCenter={false} />} />
                            </Switch>
                        }
                    />

                    <PrivateRoute
                        path='/contact/:contactId'
                        groups={adminGroups}
                        render={({ match: { url, params } }) =>
                            <Switch>
                                <Route path={`${url}`} render={() => <ContactAddEdit contactId={params.contactId} isCenter={false} centerId={0} />} />
                            </Switch>
                        }
                    />

                    <PrivateRoute
                        path='/admin'
                        groups={adminGroups}
                        render={({ match: { url, params } }) =>
                            <AdminContent url={url} params={params} />
                        }
                    />

                    <PrivateRoute
                        path='/logistics'
                        groups={logisticsGroups}
                        render={({ match: { url, params } }) =>
                            <Switch>
                                <Route path={`${url}/swaps`} component={CourierLogistics} />
                                <Route path={`${url}/move-tracker`} render={() => <MoveTracker reloadCounts={null} isOps={false} isCourier={true} />} />
                                <Route path={`${url}/upcoming-swap-calls`} component={CourierSwapCallsScheduleReport} />
                                <Route path={`${url}/organ-pickup-delivery`} component={OrganPickupDeliveryReport} />
                            </Switch>
                        }
                    />

                    <PrivateRoute
                        path='/nkr-lab'
                        groups={nkrLabGroups}
                        render={({ match: { url, params } }) =>
                            <Switch>
                                <Route path={`${url}/donor-options/:donorAlias`} component={NkrlabDonorOptions} />
                                <Route path={`${url}`} component={Nkrlab} />
                            </Switch>
                        }
                    />

                    <PrivateRoute
                        path='/center/:id'
                        groups={centerGroups}
                        render={({ match: { url, params } }) =>
                            <Switch>
                                <Route
                                    path={`${url}/action-center`}
                                    render={({ match: { url, params: actionCenterParams } }) => (
                                        <CenterActionCenterRoutes url={url} {...params} />
                                    )}
                                />

                                <Route
                                    path={`${url}/cheek-swab-request/donor/:donorId`}
                                    render={({ match: { url, params } }) =>
                                        <CheekSwabRequest centerId={params.centerId} donorId={params.donorId} recipientId={0} isModal={false} />
                                    }
                                />

                                <Route
                                    path={`${url}/cheek-swab-request/recipient/:recipientId`}
                                    render={({ match: { url, params } }) =>
                                        <CheekSwabRequest centerId={params.centerId} donorId={0} recipientId={params.recipientId} isModal={false} />
                                    }
                                />

                                <Route
                                    path={`${url}/billing`}
                                    render={({ match: { url, params: billingParams } }) => (
                                        <CenterBillingRoutes url={url} {...params} />
                                    )}
                                />

                                <Route
                                    path={`${url}/microsite`}
                                    render={({ match: { url, params: micrositeParams } }) => (
                                        <CenterMicrositeRoutes url={url} {...params} />
                                    )}
                                />

                                <Route
                                    path={`${url}/recipient`}
                                    render={({ match: { url, params: recipientParams } }) => (
                                        <CenterRecipientRoutes url={url} {...params} />
                                    )}
                                />

                                <Route
                                    path={`${url}/recipients`}
                                    render={({ match: { url, params: recipientParams } }) => (
                                        <Switch>
                                            <Route exact path={`${url}/donor-pre-select`} render={({ match: { params: subParams } }) => <CenterAdmin {...subParams} centerId={params.id} section='RECIPIENTS' subSection='DONOR-PRE-SELECT' />} />
                                            <Route exact path={`${url}/recipient-shield`} render={({ match: { params: subParams } }) => <CenterAdmin {...subParams} centerId={params.id} section='RECIPIENTS' subSection='RECIPIENT-SHIELD' />} />
                                            <Route exact path={`${url}/import-waitlist`} render={({ match: { params: subParams } }) => <CenterAdmin {...subParams} centerId={params.id} section='RECIPIENTS' subSection='IMPORT-WAITLIST' />} />
                                            <Route exact path={`${url}/voucher-holders`} render={({ match: { params: subParams } }) => <CenterAdmin {...subParams} centerId={params.id} section='RECIPIENTS' subSection='VOUCHER-HOLDERS' />} />
                                            <Route exact path={`${url}/transplanted-recipients`} render={({ match: { params: subParams } }) => <CenterAdmin {...subParams} centerId={params.id} section='RECIPIENTS' subSection='TRANSPLANTED-RECIPIENTS' />} />
                                            <Route exact path={`${url}/donor-shield-direct`} render={({ match: { params: subParams } }) => <CenterAdmin {...subParams} centerId={params.id} section='RECIPIENTS' subSection='DONOR-SHIELD-DIRECT' />} />
                                            <Route exact path={`${url}`} render={({ match: { params: subParams } }) => <CenterAdmin {...subParams} centerId={params.id} section='RECIPIENTS' subSection='RECIPIENT-LIST' />} />
                                            <CenterPassRoutes url={url} {...params} />
                                        </Switch>
                                    )}
                                />

                                <Route
                                    path={`${url}/donor`}
                                    render={({ match: { url, params: donorParams } }) => (
                                        <Switch>
                                            <Route exact path={`${url}/:donorId/voucher/:voucherHolderId`} render={({ match: { params: subParams } }) =>
                                                <CenterAdmin {...subParams} centerId={params.id} section='DONOR' subSection={donorSubsections.PROFILE} tertiarySection={'VOUCHER-EDIT'} itemId={subParams.donorId} voucherHolderId={subParams.voucherHolderId} />} />

                                            <Route exact path={`${url}/:donorId/voucher/add`} render={({ match: { params: subParams } }) =>
                                                <CenterAdmin {...subParams} centerId={params.id} section='DONOR' subSection={donorSubsections.PROFILE} tertiarySection={'VOUCHER-ADD'} itemId={subParams.donorId} />} />

                                            <Route exact path={`${url}/:donorId/vouchers`} render={({ match: { params: subParams } }) =>
                                                <CenterAdmin {...subParams} centerId={params.id} section='DONOR' subSection={donorSubsections.PROFILE} tertiarySection={'VOUCHERS'} itemId={subParams.donorId} />} />

                                            <Route exact path={`${url}/:donorId/voucher-holder/:voucherHolderId`} render={({ match: { params: subParams } }) =>
                                                <CenterAdmin {...subParams} centerId={params.id} section='DONORS' subSection='VOUCHER-HOLDER-EDIT' donorId={subParams.donorId} itemId={subParams.voucherHolderId} />} />

                                            <Route
                                                path={`${url}/:donorId/profile`}
                                                render={({ match: { url, params: donorProfileParams } }) => (
                                                    <Switch>
                                                        <Route exact path={`${url}/:section`} render={({ match: { params: subParams } }) =>
                                                            <CenterAdmin {...params} centerId={params.id} section='DONOR' subSection={donorSubsections.PROFILE} tertiarySection={subParams.section.toUpperCase()} itemId={donorProfileParams.donorId} />} />
                                                        <Route exact path={`${url}/`} render={({ match: { params: subParams } }) =>
                                                            <CenterAdmin {...params} centerId={params.id} section='DONOR' subSection={donorSubsections.PROFILE} tertiarySection={donorProfileSections.DONOR_DATA} itemId={donorProfileParams.donorId} />} />
                                                    </Switch>
                                                )} />

                                            <Route exact path={`${url}/add`} render={({ match: { params: subParams } }) =>
                                                <CenterAdmin {...params} centerId={params.id} section='DONOR' subSection='ADD' />} />
                                        </Switch>
                                    )}
                                />

                                <Route
                                    path={`${url}/donors`}
                                    render={({ match: { url, params: donorsParams } }) => (
                                        <Switch>
                                            <Route exact path={`${url}/voucher-program`} render={({ match: { params: subParams } }) => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.VOUCHER_PROGRAM} tertiarySection={""} />} />
                                            <Route exact path={`${url}/search`} render={({ match: { params: subParams } }) => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.SEARCH} tertiarySection={""} />} />
                                            <Route exact path={`${url}/donor-intake/to-do`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection='DONOR-INTAKE' tertiarySection={donorSubsections.TODO} />} />
                                            <Route exact path={`${url}/donor-intake/search`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection='DONOR-INTAKE' tertiarySection={donorSubsections.ALL} />} />
                                            <Route exact path={`${url}/donor-intake/search-by-intended`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection='DONOR-INTAKE' tertiarySection={donorSubsections.SEARCH_INTENDED} />} />
                                            <Route exact path={`${url}/donor-intake/diagnostics/:regId`} render={({ match: { params: subParams } }) => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection='DONOR-INTAKE' itemId={parseInt(subParams.regId)} tertiarySection={donorSubsections.EDIT_DIAGNOSTICS} />} />
                                            <Route exact path={`${url}/donor-intake/details/:regId`} render={({ match: { params: subParams } }) => <CenterAdmin {...subParams} centerId={params.id} section='DONORS' subSection='DONOR-INTAKE' tertiarySection={donorSubsections.DETAILS} itemId={parseInt(subParams.regId)} />} />
                                            <Route exact path={`${url}/donor-intake/send-email/:regId`} render={({ match: { params: subParams } }) => <CenterAdmin {...subParams} centerId={params.id} section='DONORS' subSection='DONOR-INTAKE' tertiarySection={donorSubsections.SEND_EMAIL} itemId={parseInt(subParams.regId)} />} />
                                            <Route exact path={`${url}/donor-intake/donor-connect-confirm`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection='DONOR-INTAKE' tertiarySection={donorSubsections.DONOR_CONNECT_CONFIRM} />} />
                                            <Route exact path={`${url}/donor-intake/confirm-address`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection='DONOR-INTAKE' tertiarySection={donorSubsections.CONFIRM_ADDRESS} />} />
                                            <Route exact path={`${url}/donor-intake/pwl/details/:regId`} render={({ match: { params: subParams } }) => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection='DONOR-INTAKE' tertiarySection={donorSubsections.PWL_DETAILS} itemId={parseInt(subParams.regId)} />} />
                                            <Route exact path={`${url}/swap`} render={({ match: { params: subParams } }) => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.SWAP} tertiarySection='SWAP' />} />
                                            <Route exact path={`${url}/reconciliation`} render={({ match: { params: subParams } }) => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.RECONCILIATION} />} />
                                            <Route exact path={`${url}/watr`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} />} />
                                            <Route exact path={`${url}/donor-shield-direct/pending-transplant`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.DONOR_SHIELD_DIRECT} tertiarySection='PENDING-TRANSPLANT' />} />
                                            <Route exact path={`${url}/donor-shield-direct/transplanted`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.DONOR_SHIELD_DIRECT} tertiarySection='TRANSPLANTED' />} />
                                            <Route exact path={`${url}/donor-shield-direct/add-donor`} render={({ match: { params: subParams } }) => <CenterAdmin {...subParams} centerId={params.id} section='DONORS' subSection={donorSubsections.DONOR_SHIELD_DIRECT} tertiarySection='ADD-DONOR' itemId={0} />} />
                                            <Route exact path={`${url}/donor-shield-direct/edit-donor/:donorId`} render={({ match: { params: subParams } }) => <CenterAdmin {...subParams} centerId={params.id} section='DONORS' subSection={donorSubsections.DONOR_SHIELD_DIRECT} tertiarySection='EDIT-DONOR' itemId={parseInt(subParams.donorId)} />} />
                                            <Route
                                                path={`${url}/watr`}
                                                render={({ match: { url, params: watrParams } }) => (
                                                    <Switch>
                                                        <Route exact path={`${url}/add-request`} render={({ match: { params: subParams } }) => <CenterAdmin {...subParams} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='ADD-REQUEST' />} />
                                                        <Route exact path={`${url}/add-request/:donorId`} render={({ match: { params: subParams } }) => <CenterAdmin {...subParams} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='ADD-REQUEST' itemId={parseInt(subParams.donorId)} />} />
                                                        <Route exact path={`${url}/edit-request/:donorId`} render={({ match: { params: subParams } }) => <CenterAdmin {...subParams} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='EDIT-REQUEST' itemId={parseInt(subParams.donorId)} />} />
                                                        <Route path={`${url}/search`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='SEARCH' />} />
                                                        <Route path={`${url}/not-reimbursed`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='NOT-REIMBURSED' />} />
                                                        <Route path={`${url}/reimbursed`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='REIMBURSED' />} />
                                                        <Route path={`${url}/donated`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='DONATED' />} />
                                                        <Route path={`${url}/pend-travel`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='PEND-TRAVEL' />} />
                                                        <Route path={`${url}/pend-receipts`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='PEND-RECEIPTS' />} />
                                                        <Route path={`${url}/pend-wage`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='PEND-WAGE' />} />
                                                        <Route path={`${url}/pend-surgery`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='PEND-SURGERY' />} />
                                                        <Route path={`${url}/pend-verify`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='PEND-VERIFY' />} />
                                                        <Route path={`${url}/pend-doc`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='PEND-DOC' />} />
                                                        <Route path={`${url}/pend-registration`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='PEND-REGISTRATION' />} />
                                                        <Route path={`${url}/advanced-reimbursement`} render={() => (
                                                            (!isAdvReimburseEnabledCentersLoaded() || isAdvReimburseEnabledForCenter(parseInt(params.id)))
                                                                ? <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='ADVANCED-REIMBURSEMENT' />
                                                                : <Redirect to={`${url}`} />
                                                        )} />
                                                        <Route path={`${url}/pend-payment-to-do`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='PEND-PAYMENT-TO-DO' />} />
                                                        <Route path={`${url}/pend-verify-to-do`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='PEND-VERIFY-TO-DO' />} />
                                                        <Route path={`${url}/pend-payment`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} tertiarySection='PEND-PAYMENT' />} />
                                                        <Route exact path={`${url}`} render={() => <CenterAdmin {...params} centerId={params.id} section='DONORS' subSection={donorSubsections.WAGE_AND_TRAVEL} />} />
                                                    </Switch>
                                                )}
                                            />
                                        </Switch>
                                    )}
                                />

                                <Route
                                    path={`${url}/profile`}
                                    render={({ match: { url, params: profileParams } }) => (
                                        <CenterProfileRoutes url={url} {...params} />
                                    )}
                                />

                                <Route
                                    path={`${url}/expert-system`}
                                    render={({ match: { url, params: expertSystemParams } }) => (
                                        <Switch>
                                            <Route path={`${url}/view-order/:orderId`} render={({ match: { params: subParams } }) => <ViewExpertSystemOrder centerId={parseInt(params.id)} orderId={parseInt(subParams.orderId)} />} />
                                            <Route path={`${url}/:statusId?`} render={({ match: { params: subParams } }) => <CenterAdmin {...params} centerId={parseInt(params.id)} section='EXPERT-SYSTEM' itemId={parseInt(subParams.statusId)} />} />
                                        </Switch>
                                    )}
                                />

                                <Route
                                    path={`${url}/reports`}
                                    render={({ match: { url, params: reportParams } }) => (
                                        <CenterReportRoutes url={url} {...params} />
                                    )}
                                />

                                <Route
                                    path={`${url}/incident-report-details`}
                                    render={({ match: { url, params: reportParams } }) => (
                                        <Switch>
                                            <Route path={`${url}/:id`} render={({ match: { params: subParams } }) => <CenterAdmin {...params} centerId={parseInt(params.id)} section='INCIDENT-REPORT' itemId={parseInt(subParams.id)} />} />
                                        </Switch>
                                    )}
                                />

                                <Route
                                    path={`${url}/follow-up`}
                                    render={({ match: { url, params: followUpParams } }) => (
                                        <CenterFollowUpRoutes url={url} {...params} />
                                    )}
                                />

                                <Route
                                    path={`${url}/legal`}
                                    render={({ match: { url, params: followUpParams } }) => (
                                        <CenterAdmin {...params} centerId={params.id} section='LEGAL' />
                                    )}
                                />

                                <Route
                                    path={`${url}/regulatory-compliance`}
                                    render={({ match: { url, params: followUpParams } }) => (
                                        <CenterAdmin {...params} centerId={params.id} section='REGULATORY-COMPLIANCE' />
                                    )}
                                />

                                <Route
                                    path={`${url}/network-email-repository`}
                                    render={() => (
                                        <CenterAdmin {...params} centerId={params.id} section='NETWORK-EMAIL-REPOSITORY' />
                                    )}
                                />

                                <Route path={`${url}`} render={() => <CenterAdmin {...params} centerId={params.id} section='ACTION-CENTER' subSection='TO-DO' />} />
                            </Switch>
                        }
                    />

                    <PrivateRoute
                        path='/microsite/coach'
                        groups={micrositeCoachGroups}
                        render={({ match: { url } }) =>
                            <Switch>
                                <Route path={`${url}/report/microsite-coach-performance`} render={() => <MicrositeCoachPerformance isSuperAdmin={false} />} />
                                <Route path={`${url}/to-do`} render={() => <CoachFilteredList tab={CoachListTab.PendingFollowUp} />} />
                                <Route path={`${url}/approval`} render={() => <CoachFilteredList tab={CoachListTab.Approval} />} />
                                <Route path={`${url}/opted-out`} render={() => <CoachFilteredList tab={CoachListTab.OptedOut} />} />
                                <Route path={`${url}/all`} render={() => <CoachFilteredList tab={CoachListTab.All} />} />
                                <Route path={`${url}/approve/:id`} render={({ match: { params: subParams } }) => <MicrositeApprove micrositeId={subParams.id} centerId={null} isAdmin={true} isCoachView={true} previousUrl={'microsite/coach/approval'} />} />
                                <Route path={`${url}/decline/:id`} render={({ match: { params: subParams } }) => <MicrositeDecline micrositeId={subParams.id} centerId={null} isAdmin={true} previousUrl={'microsite/coach/approval'} />} />
                                <Route path={`${url}/history/:id`} render={({ match: { params: subParams } }) => <MicrositeRecipientHistory micrositeId={subParams.id} centerId={null} isAdmin={true} previousUrl={''} />} />
                                <Route path={`${url}/registration/:id`} render={({ match: { params: subParams }, location }) => <MicrositeAddEdit micrositeId={parseInt(subParams.id)} centerId={null} isAdmin={true} isCoachView={true} isConfirm={false} previousUrl={new URLSearchParams(location.search).get('returnTo') ?? 'microsite/coach'} previousName='Coach View' />} />
                                <Route path={`${url}/new-assignments`} render={() => <CoachFilteredList tab={CoachListTab.NewAssignments} />} />
                                <Route path={`${url}/declined-cs`} render={() => <CoachFilteredList tab={CoachListTab.DeclinedCs} />} />
                                <Route path={`${url}/:id`} render={({ match: { params: subParams } }) => <CoachMicrositeView micrositeId={subParams.id} />} />
                                <Route path={`${url}/`} render={() => <CoachActionCenter />} />
                            </Switch>
                        }
                    />

                    <PrivateRoute
                        path='/donor-connect'
                        groups={donorConnectGroups}
                        render={({ match: { url, params } }) =>
                            <DonorConnectRoutes url={url} />
                        }
                    />

                    <PrivateRoute
                        path='/ilda'
                        groups={donorConnectGroups}
                        render={({ match: { url, params } }) =>
                            <Switch>
                                <Route path={`${url}/user-case-load-limits`} component={IldaUserCaseLoadLimits} />
                                <Route path={`${url}/unassigned`} component={IldaApp} />
                                <Route path={`${url}/to-do`} component={IldaApp} />
                                <Route path={`${url}/assigned-to-me`} component={IldaApp} />
                                <Route path={`${url}/all`} component={IldaApp} />
                                <Route path={`${url}/`} component={IldaApp} />
                            </Switch>
                        }
                    />

                    <PrivateRoute path='/target' groups={adminGroups} render={() => <Redirect to={`/target-new`} />} />

                    <PrivateRoute path='/target-new' groups={adminGroups} component={TargetNew} />

                    <PrivateRoute path='/high-declines' groups={adminGroups} component={HighDeclines} />

                    <PrivateRoute path='/swap-call-schedule-report' groups={adminGroups} component={SwapCallsScheduleReport} />

                    <PrivateRoute path='/opo-portal/:opoId(\d+)' groups={adminGroups} component={OpoPortalEntry} />

                    <PrivateRoute
                        path='/opo'
                        groups={opoGroups}
                        render={({ match: { url, params } }) =>
                            <Switch>
                                <Route path={`${url}/ach-information`} component={OpoUserOpoEdit} />
                                {/* <Route path={`${url}/move-tracker`} component={OpoMoveTracker} /> */}
                                <Route
                                    path={`${url}/strongbox`}
                                    render={({ match: { url, params } }) =>
                                        <Switch>
                                            <Route path={`${url}/inventory`} render={() => <StrongBoxListing tabKey={0} isOpo={true} />} />
                                            <Route path={`${url}/orders`} render={() => <StrongBoxListing tabKey={1} isOpo={true} />} />
                                            <Route path={`${url}/usage-history`} render={() => <StrongBoxListing tabKey={2} isOpo={true} />} />
                                            <Route path={`${url}/inventory-reports`} render={() => <StrongBoxListing tabKey={3} isOpo={true} />} />
                                        </Switch>
                                    }
                                />
                                <Route path={`${url}/`} component={OpoLandingPage} />
                            </Switch>
                        }
                    />

                    <Route exact path='/' component={Home} />
                    <Route path='' component={NotFound} />
                </Switch>
            </AppHookProvider>
        </Layout>
    );
}

export const routes = (
    <App>
        <AppHookProvider>
            <Switch>
                <Route exact path='/login' component={Login} />
                <Route exact path='/not-authorized' component={NotAuthorized} />
                <Route exact path='/logout' component={Logout} />
                <Route exact path='/select-account' component={SelectAccount} />

                <Route exact path='/update-optn-srtr-data' component={UpdateOptnSrtrData} />

                <Route
                    path='/logistics/position/:donorId/:recipientId'
                    render={({ match: { url, params } }) =>
                        <Switch>
                            <Route path={`${url}`} render={() => <Print><LogisticsPlan donorId={params.donorId} recipientId={params.recipientId} /></Print>} />
                        </Switch>
                    }
                />

                <Route path='/create-account' component={CreateAccount} />
                <Route path='/center/:centerId' component={Parent} />
                <Route path='/' component={Parent} />
            </Switch>
        </AppHookProvider>
    </App>
);
